import React from "react";
import ButtonComponent from "../ButtonComponent";

type BuyProductProps = { 
    product: any;
    buttonText: string;
    quantity: number;
    styles?: React.CSSProperties;
};

const AddToCartButton = ({ product, buttonText, quantity, styles }: BuyProductProps) => {

    return (
        <ButtonComponent className="w-full" type="primary" label={buttonText} onClick={() => console.log('clique')} />
    );
};

export default AddToCartButton;
